(function () {
  // Reveal on scroll
  var els = document.querySelectorAll('.zan-reveal');
  if ('IntersectionObserver' in window && els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Product forms: quantity, total, free-shipping nudge, variant select
  var productCleanups = new WeakMap();
  function initProduct(root) {
    if (productCleanups.has(root)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var sticky = root.querySelector('[data-zan-sticky]');
    var stickyTotal = root.querySelector('[data-zan-sticky-total]');
    var stickyQuantity = root.querySelector('[data-zan-sticky-quantity]');
    var stickyObserver;
    var mobile = window.matchMedia('(max-width: 749px)');
    productCleanups.set(root, function () { controller.abort(); if (stickyObserver) stickyObserver.disconnect(); productCleanups.delete(root); });
    var input = root.querySelector('input[name="quantity"]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var total = root.querySelector('[data-zan-total]');
    var nudge = root.querySelector('[data-zan-nudge]');
    var select = root.querySelector('[data-zan-variant]');
    var idInput = root.querySelector('input[name="id"]');
    var threshold = parseInt(root.getAttribute('data-free-qty') || '2', 10);
    var price = parseInt(root.getAttribute('data-price') || '0', 10);
    var fmt = root.getAttribute('data-money-format') || '€{{amount}}';

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      var comma = v.replace('.', ',');
      var formatted = fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, v);
      return cents % 100 === 0 ? formatted.replace(/[.,]00(?!\d)/, '') : formatted;
    }
    function update() {
      if (!input) return;
      var q = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
      input.value = q;
      if (total) total.textContent = money(price * q);
      if (stickyTotal) stickyTotal.textContent = money(price * q);
      if (stickyQuantity) stickyQuantity.textContent = q;
      if (nudge) {
        var left = threshold - q;
        nudge.classList.toggle('is-unlocked', left <= 0);
        var t = nudge.querySelector('span');
        if (t) t.textContent = left <= 0
          ? nudge.getAttribute('data-done')
          : nudge.getAttribute('data-todo').replace('[n]', left).replace('[s]', left === 1 ? '' : 's');
      }
    }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); update(); }, { signal: signal });
    if (plus) plus.addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); update(); }, { signal: signal });
    if (input) input.addEventListener('change', update, { signal: signal });
    if (select && idInput) select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex];
      idInput.value = o.value;
      price = parseInt(o.getAttribute('data-price') || price, 10);
      update();
    }, { signal: signal });
    if (sticky && 'IntersectionObserver' in window) {
      var buyRow = root.querySelector('.zan-buy__row');
      function syncSticky() {
        sticky.hidden = !mobile.matches || buyRow.getBoundingClientRect().bottom >= 0;
      }
      stickyObserver = new IntersectionObserver(syncSticky, { threshold: 0 });
      stickyObserver.observe(buyRow);
      mobile.addEventListener('change', syncSticky, { signal: signal });
      syncSticky();
    }
    update();
  }
  document.querySelectorAll('[data-zan-buy]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-zan-buy]').forEach(initProduct);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-zan-buy]').forEach(function (root) {
      var cleanup = productCleanups.get(root);
      if (cleanup) cleanup();
    });
  });

  // Mobile gallery counter
  document.querySelectorAll('[data-zan-gallery]').forEach(function (g) {
    var counter = g.parentElement.querySelector('[data-zan-count]');
    var items = g.children.length;
    if (!counter || items < 2) return;
    g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / g.clientWidth) + 1;
      counter.textContent = i + ' / ' + items;
    }, { passive: true });
  });
})();
